import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataDriven = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M3.33325 16.6667V7.49999H6.66658V16.6667H3.33325ZM3.33325 6.66666V3.33333H6.66658V6.66666H3.33325ZM8.33325 16.6667V9.99999H11.6666V16.6667H8.33325ZM8.33325 9.16666V5.83333H11.6666V9.16666H8.33325ZM13.3333 16.6667V12.5H16.6666V16.6667H13.3333ZM13.3333 11.6667V8.33333H16.6666V11.6667H13.3333Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDataDriven);
export default ForwardRef;
